const createPermissions = permissions => {
  return Object.freeze(
    permissions.reduce((acc, permission) => {
      acc[permission] = permission
      return acc
    }, {}),
  )
}

export const ADMIN_PERMISSIONS = createPermissions([
  'LINK_AS_CLIENT',
  'VIEW_REGISTRATION_REQUESTS',
  'PERFORM_REGISTRATION_REQUESTS_PANEL_ACTIONS',
  'VIEW_INDICATIONS_AND_PARTNERSHIP_PANEL',
  'PERFORM_INDICATIONS_AND_PARTNERSHIP_PANEL_ACTIONS',
  'VIEW_CLIENT_ACCOUNT_DATA',
  'VIEW_CLIENT_ACCOUNT_LIMITS',
  'CHANGE_CLIENT_ACCOUNT_LIMITS',
  'VIEW_CLIENT_PLANS_SERVICES',
  'CHANGE_CLIENT_PLANS_SERVICES',
  'CHANGE_CLIENT_MANAGER',
  'VIEW_VALUE_BLOCKAGE_PANEL',
  'PERFORM_VALUE_BLOCKAGE_PANEL_ACTIONS',
  'VIEW_CASH_OUT',
  'PERFORM_CASH_OUT_PANEL_ACTIONS',
  'CORRECT_TRANSACTION_STATEMENT',
  'VIEW_DEPOSIT_RECOGNITION_PANEL',
  'PERFORM_DEPOSIT_RECOGNITION_PANEL_ACTIONS',
  'VIEW_DEBT_ADVANCEMENT_PANEL',
  'PERFORM_DEBT_ADVANCEMENT_PANEL_ACTIONS',
  'VIEW_DEBENTURES_PANEL',
  'PERFORM_DEBENTURES_PANEL_ACTIONS',
  'VIEW_PAYMENT_ORDERS',
  'VIEW_PLANS_SERVICES',
  'VIEW_IMOBANCO_FEES',
  'REGISTER_IMOBANCO_FEES',
  'ACCOUNTING_AREA',
  'ISSUE_REPORTS',
  'ADMINISTRATIVE_USER_REGISTRATION',
])

export const ADMIN_ROLES = createPermissions([
  'ACCOUNT_MANAGER',
  'COMMERCIAL',
  'SUPPORT',
  'CUSTOMER_SERVICE',
  'ACCOUNTING',
  'FINANCIAL',
  'COMPLIANCE',
  'CREDIT',
  'JURIDICAL',
  'HUMAN_DEVELOPMENT',
  'ADMIN_MASTER',
])

export const USER_PERMISSIONS = {}
